import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodingameComponent } from './simple-icons-codingame.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodingameComponent ],
    exports:      [ SimpleIconsCodingameComponent ],
    bootstrap:    []
})
export class SimpleIconsCodingameModule {}
